import { darken, lighten, useTheme } from '@mui/material';
import { ColorMode } from 'theme';

const useReadableTextColors = () => {
  const theme = useTheme();
  // The least change that keeps 4.5:1 contrast on mutedSgGreen
  const readable = (
    color: string,
    lightModeDarkening: number,
    darkModeLightening = 0,
  ) => {
    if (theme.colorMode === ColorMode.LIGHT) {
      return darken(color, lightModeDarkening);
    }
    if (theme.colorMode === ColorMode.DARK && darkModeLightening > 0) {
      return lighten(color, darkModeLightening);
    }
    return color;
  };
  return {
    sgGreen: readable(theme.palette.sgGreen, 0.36),
    error: readable(theme.palette.error.main, 0.29, 0.21),
    success: readable(theme.palette.success.main, 0.35),
  };
};

export default useReadableTextColors;
